module.exports = { 
  content: { 
    productDetail: "Product Detail",
    productReviews: "Product Reviews",
    commodity: "Commodity Q&A",
  } 
} 


// WEBPACK FOOTER //
// ./src/assets/lang/en-us/productDetail.js